import { DEVICE_TYPE } from '@/types';


export const device = (set) => {
    return {
        device: DEVICE_TYPE.PC,
        setDevice: (next: DEVICE_TYPE) => {
            set((state) => ({
                device: next,
            }));
        },
    };
};
